



























































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import MediaItem from '@/store/entities/MediaItem'
    import MediaCropp from '@/store/entities/mediacropp'
    import { EventBus } from '@/lib/eventbus';
    import Gallery from '@/store/entities/gallery'
    import { VueCropper }  from "vue-cropper"

    import { Cropper,Preview } from 'vue-advanced-cropper'
    import 'vue-advanced-cropper/dist/style.css';
    @Component({
        components:{VueCropper,Cropper,Preview}
    })
    export default class EditGallery extends AbpBase{
        gallery:Gallery = new Gallery();
        spinShow: boolean = true;
        cacheKey:number = +new Date();
        @Prop({type:Boolean,default:false}) value:boolean;
        result={
			coordinates: {
                width: 0,
                height: 0,
                left: 0,
                top: 0,
            },
			image: null
		}
        aspect= 16/9;
        form={
            description:''
        } 
        formGallery={
            shortDescription:''
        } 
        get categories() {
            return this.$store.state.gallery.categories;
        }
        croppData:MediaCropp = new MediaCropp();    
        get mediaItem(){
            return this.$store.state.medialist.editMediaItem as MediaItem;
        }
        async croppImage(){  
            this.croppData.id =this.gallery.featuredFileId;
            this.croppData.height =this.result.coordinates.height;
            this.croppData.width =this.result.coordinates.width;
            this.croppData.top =this.result.coordinates.left;
            this.croppData.left =this.result.coordinates.top;
            await this.$store.dispatch({
                type: "mediamanager/croppImage",
                data: this.croppData
            }).then( (result)=> {
                (this.$refs.form as any).resetFields();
                this.$router.push({ name: "gallery" });       
            });
        }
        changeHeight(value){         
            if (!Number.isInteger(value)) {
                return false;
            }
            this.aspect=null;
            //@ts-ignore
            this.$refs.cropper.setCoordinates({height:value});
        }
        changeWidth(value){
            if (!Number.isInteger(value)) {
                return false;
            }
            this.aspect=null;
            //@ts-ignore
            this.$refs.cropper.setCoordinates({width:value});
        }
        changeTop(value){
            if (!Number.isInteger(value)) {
                return false;
            }
            //@ts-ignore
            this.$refs.cropper.setCoordinates({top:value});
        }
        changeLeft(value){
            if (!Number.isInteger(value)) {
                return false;
            }
            //@ts-ignore
            this.$refs.cropper.setCoordinates({left:value});
        }
        async save(){
            let data = this.gallery;
            // await this.$store.dispatch({
            //     type:'medialist/updateProps',
            //     data:data
            // });
            //data.id = data.galleryId;
            //data.galleryCategories = this.form.categories;
            await this.$store.dispatch({
                type:'gallery/update',
                data:data
            }).then( () => {
                (this.$refs.form as any).resetFields();
                this.$router.push({ name: "gallery" });  
            })
        }
          async getpage() {
            var galleryId = this.$route.params.galleryId;
            if (parseInt(galleryId) > 0) {
            await this.$store
                .dispatch({
                type: "gallery/get",
                data: { Id: galleryId },
                })
                .then((result) => {
                this.gallery = result;
                this.spinShow = false;
                });
            } else {
            this.spinShow = false;
            };
            await this.$store.dispatch({
            type: "gallery/getAllCategories",
            });
        }
        async created() {
            this.getpage();
        }
        cancel(){
            (this.$refs.form as any).resetFields();
            this.$router.push({ name: "gallery" });
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }else{
            }
            
        }
        change({ coordinates, image  }) {
            this.result = {
				coordinates,
				image
			};
		}
        validateNumber = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('Nie może być puste'));
                }
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('Proszę wpisac numer'));
                    } else {
                        callback();
                    }
                }, 1000);
            };
        ruleCustom= {
            height: [
                { validator: this.validateNumber, trigger: 'blur' }
            ],
            width: [
                { validator: this.validateNumber, trigger: 'blur' }
            ],
            top: [
                { validator: this.validateNumber, trigger: 'blur' }
            ],
            left: [
                { validator: this.validateNumber, trigger: 'blur' }
            ]
        }
    }
